import React, { PropsWithChildren } from 'react'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import Styles from './PersistentToast.module.scss'
import { Close } from 'blaze-ui/icons'
import { Text, TextVariant } from 'blaze-ui/Text/Text'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface HeaderProps {
  onClose?: () => void
  icon?: React.ReactNode
  showCloseButton?: boolean
  titleVariant?: TextVariant
}

export const Icon = ({ children }: PropsWithChildren) => <div className={Styles.icon}>{children}</div>

export const Title = ({ children, variant = 'secondaryDark' }: PropsWithChildren<{ variant?: TextVariant }>) => {
  const { isMobile } = useResponsiveDesign()

  return (
    <div className={Styles.title}>
      <Text variant={variant} lineClamp={isMobile ? undefined : 1}>
        {children}
      </Text>
    </div>
  )
}

export const CloseButton = ({ onClose }: { onClose?: () => void }) => (
  <div className={Styles.closeButton}>
    <IconButton onPress={onClose} icon={Close} variant="tertiary" size="sm" />
  </div>
)

export const Header = ({ children, icon, showCloseButton, onClose, titleVariant }: PropsWithChildren<HeaderProps>) => {
  return (
    <div className={Styles.header}>
      {icon && <Icon>{icon}</Icon>}
      <Title variant={titleVariant}>{children}</Title>
      {showCloseButton && <CloseButton onClose={onClose} />}
    </div>
  )
}
